import { render, staticRenderFns } from "./RecommendedTrips.vue?vue&type=template&id=7a5f1fbf&scoped=true"
import script from "./RecommendedTrips.vue?vue&type=script&lang=js"
export * from "./RecommendedTrips.vue?vue&type=script&lang=js"
import style0 from "./RecommendedTrips.vue?vue&type=style&index=0&id=7a5f1fbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5f1fbf",
  null
  
)

export default component.exports